import { inject, InjectionToken } from '@angular/core';
import { distinctUntilChanged, filter, map, shareReplay } from 'rxjs/operators';
import { PartnerService } from '@galaxy/partner';
import { ConfigManagerConfig } from '@vendasta/config-manager';
import { AppConfigService } from '../app-config.service';

export const CONFIG_MANAGER_CONFIG = new InjectionToken<ConfigManagerConfig>(
  '[ConfigManager]: token for configuration',
  {
    providedIn: 'root',
    factory: () => {
      const partnerService = inject(PartnerService);
      const appConfigService = inject(AppConfigService);

      const partnerId$ = partnerService.getPartnerId().pipe(
        map((partnerId) => partnerId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
      const isSuperAdmin$ = appConfigService.config$.pipe(
        map((config) => config.isSuperAdmin ?? false),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
      const userId$ = appConfigService.config$.pipe(
        map((config) => config.unifiedUserId),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      return {
        partnerId$,
        isSuperAdmin$,
        userId$,
      };
    },
  },
);
